import type { KaiHomeContext } from "@/services/kaiApi";
import type { HomeWidget } from "@/types/home";

/**
 * Module-level snapshot of the current Home dashboard, published by the Home
 * page's `useHomeEditor` while it is mounted. `KaiChatContext` (which lives
 * above the routed page tree and has no direct access to the editor state)
 * reads it when assembling `client_context` for a Kai turn on `/dashboard`.
 *
 * This mirrors the table-context snapshot pattern (`buildKaiTableContext`).
 */
let currentSnapshot: KaiHomeContext | null = null;

export function setKaiHomeContext(snapshot: KaiHomeContext | null): void {
  currentSnapshot = snapshot;
}

export function homeWidgetsToContext(
  widgets: HomeWidget[],
  kaiSessionActive: boolean,
): KaiHomeContext {
  return {
    widgets: widgets.map((w) => ({
      widget_key: w.widget_key,
      widget_type: w.widget_type,
      title: w.title,
    })),
    kai_session_active: kaiSessionActive,
  };
}

/**
 * The Home-layout snapshot Kai receives in `client_context.home_context` for
 * the current route, or `undefined` when the user is not on the dashboard (or
 * the Home page has not published a snapshot yet).
 */
export function buildKaiHomeContext(
  pathname: string,
): KaiHomeContext | undefined {
  if (pathname !== "/dashboard") return undefined;
  return currentSnapshot ?? undefined;
}
